




// @ is an alias to /src
import { Vue, Component } from "vue-property-decorator";
import HistoryOrder from "@/components/history/historyOrder.vue";

@Component({
  name: "OrderHistoriesPage",
  components: {HistoryOrder},
})
export default class OrderHistoriesPage extends Vue {}
